import { SerializedStyles } from '@emotion/react';
import React from 'react';
import { css } from 'twin.macro';

interface IProps {
    icon: React.FC<{ className?: string }>;
    className?: string;
    svgCSS?: SerializedStyles;
}

// Plans -> add enum for all icons.
// TODO investigate production build when all icons will be imported from one file.
export const Icon = ({ icon, className, svgCSS }: IProps): JSX.Element => {
    const Icon = icon;
    return <Icon className={className} css={styles.root(svgCSS)} />;
};

const styles = {
    root: (svgCss: SerializedStyles | undefined): SerializedStyles => css`
        svg {
            ${svgCss}
        }
    `,
};
